import React from 'react';
import Modal from '../../components/Modal';
import ModalButton from '../../components/Modal/ModalButton';
import ModalForm from '../../components/Modal/ModalForm';
import ModalHeading from '../../components/Modal/ModalHeading';

const DeleteResourceModal = ({ data }) => {
	const { showDeleteModal, onDeleteModalClose, onDeleteHandler, selectedId } = data;

	return (
		<Modal show={showDeleteModal}>
			<ModalHeading heading='Delete Resource' onClose={onDeleteModalClose} />
			<ModalForm>
				<p className='modal__text'>Are you sure you want to delete this Resource?</p>
				<ModalButton varient='danger' label='Delete' icon='delete' onClick={() => onDeleteHandler(selectedId)} />
			</ModalForm>
		</Modal>
	);
};

export default DeleteResourceModal;
